import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemApplicationAdvancedRoute: InvariantJiraRoute = {
	name: 'global-settings-system-application-advanced',
	path: '/secure/admin/AdvancedApplicationProperties.jspa',
};
